import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './SharedStyles.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="glass-card loading-card">
            <div className="loading-content">
              <div className="loading-logo">
                <div className="logo-container">
                  <img src="/icon.png" alt="Forensic AI Logo" className="logo" />
                </div>
                <h2 className="loading-title">Forensic AI</h2>
              </div>
              <p className="loading-text">Loading...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 
